<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="text-right">
        <v-btn class="v-primary mb-1" v-on:click="handleModalCreate">
          <span class="fa fa-plus mr-1"></span>NOVO
        </v-btn>
      </div>
      <b-modal size="md" id="create" hide-footer no-close-on-backdrop>
        <template v-slot:modal-title>NOVO</template>
        <div class="d-block">
          <div class="container">
            <form v-on:submit="create" method="post">
              <div class="row">
                <div class="col-md-12 pt-0 pb-0">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                </div>
                <div class="col-md-12 pt-0 pb-0">
                  <LabelRequiredField label="NOME" />
                  <input type="text" v-model="name" class="form-control" />
                </div>
                <div class="col-md-12 pt-0 pb-0">
                  <LabelRequiredField label="VALOR" />
                  <input type="text" v-model="value" class="form-control" />
                </div>
                <div class="col-md-12 pt-0 pb-0">
                  <LabelRequiredField label="TIPO" />
                  <select v-model="type" class="form-control">
                    <option
                      v-for="item in [{ value: 'DAY', text: 'DIÁRIO' }]"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 pt-0 pb-0 text-right">
                  <v-btn
                    :disabled="loadingCreate"
                    type="submit"
                    class="v-success"
                  >
                    <span class="fa fa-check mr-1"></span>
                    {{ loadingCreate ? "CARREGANDO" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-modal>
      <v-card>
        <v-card-title>
          QUANTIDADE DIÁRIA
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          />
        </v-card-title>
        <b-overlay :show="loading" opacity="0.99">
          <v-data-table
            dense
            :search="search"
            :headers="headers"
            :items="medicine_amount_of_times"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <b-modal
                size="md"
                :id="`item_${String(item.id)}`"
                hide-footer
                no-close-on-backdrop
              >
                <template v-slot:modal-title>EDITAR</template>
                <div class="d-block">
                  <div class="container">
                    <form v-on:submit="update" method="post">
                      <div class="row">
                        <div class="col-md-12 pt-0 pb-0">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                        </div>
                        <div class="col-md-12 pt-0 pb-0">
                          <LabelRequiredField label="NOME" />
                          <input
                            type="text"
                            v-model="name"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-12 pt-0 pb-0">
                          <LabelRequiredField label="VALOR" />
                          <input
                            disabled
                            type="text"
                            v-model="value"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-12 pt-0 pb-0">
                          <LabelRequiredField label="TIPO" />
                          <select disabled v-model="type" class="form-control">
                            <option
                              v-for="item in [
                                { value: 'DAY', text: 'DIÁRIO' },
                                { value: 'SHIFTS', text: 'TURNOS' },
                              ]"
                              :key="item.value"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-6 pb-0">
                          <span class="text-muted">Criação:</span>
                          <h6>
                            {{ formatDate(item.created_at) }}
                          </h6>
                        </div>
                        <div class="col-md-6 pb-0">
                          <span class="text-muted">Última alteração:</span>
                          <h6 class="ml-2">
                            {{ formatDate(item.updated_at) }}
                          </h6>
                        </div>
                        <div class="col-md-12 pt-0 pb-0 text-right">
                          <v-btn
                            class="v-primary m-1"
                            @click="$bvModal.hide(`item_${String(item.id)}`)"
                          >
                            <span class="fa fa-arrow-left mr-1"></span> VOLTAR
                          </v-btn>
                          <v-btn
                            :disabled="loadingUpdate"
                            type="submit"
                            class="v-success"
                          >
                            <span class="fa fa-check mr-1"></span>
                            {{ loadingUpdate ? "CARREGANDO" : "SALVAR" }}
                          </v-btn>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </b-modal>
            </template>
          </v-data-table>
        </b-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";

import LabelRequiredField from "../templates/components/LabelRequiredField";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import api from "../services/api";

import NavBar from "../templates/NavBar";

import toast from "../components/ToastNotification";

import { formatDate } from "../functions/format";

export default {
  name: "MedicineAmountOfTimes",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      search: "",
      headers: [
        { text: "NOME", value: "name", sortable: false },
        {
          text: "VALOR",
          value: "value",
          sortable: false,
        },
        {
          text: "TIPO",
          value: "type",
          sortable: false,
        },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      medicine_amount_of_times: [],
      id: "",
      name: "",
      type: "",
      value: "",
      loadingCreate: false,
      loadingUpdate: false,
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];

      this.id = item.id;
      this.name = item.name;
      this.value = item.value;
      this.type = item.type;

      this.$bvModal.show(`item_${String(item.id)}`);
    },
    retrieve() {
      this.get();
    },
    async get() {
      try {
        this.loading = true;

        const response = await api.get("/admin/medicine-amount-of-times");

        const { medicine_amount_of_times } = response.data;

        this.medicine_amount_of_times = medicine_amount_of_times;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name, value, type } = this;

        let params = { name, value, type };

        const response = await api.post(
          "/admin/medicine-amount-of-times",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.errors = [];
          this.get();
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.value = "";
      this.type = "";
      this.$bvModal.show("create");
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = { id, name };

        const response = await api.put(
          "/admin/medicine-amount-of-times",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`item_${String(id)}`);
          this.get();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>